import type { WidgetRegistration } from '@ayocore/platform/client/widgets';
import { LeadFunnelWidget } from './LeadFunnelWidget';

export { LeadFunnelWidget };
export const leadFunnelWidget = {
  code: 'crm.lead-funnel',
  title: 'Лиды',
  Component: LeadFunnelWidget,
  welcome: { key: 'crm-lead-funnel', order: 60, span: 6 },
} satisfies WidgetRegistration;
